<template>
    <div class="role_warp">
      <!-- 头部工具栏 -->
      <div class="role_heard_tool">
        <!-- <el-button
          type="primary"
          class="edit-button"
          size="mini"
          @click="open('add')"
          >添加</el-button
        > -->
        <el-button
          type="success"
          size="mini"
          
          @click="getList"
          >刷新</el-button
        >
        <el-button
          type="primary"
          class="edit-button"
          size="mini"
          
          style="margin-left: 10px"
          @click="select()"
          >筛选</el-button
        >
      </div>
      <div class="head_search">
      <div class="item_warp">
        <label style="width: 44px">法币</label>
        <el-input
          v-model="currency"
          placeholder="请输入法币"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
    </div>
      <!-- 表单 -->
      <el-table
        ref="gridTable"
        v-loading="loading"
        :data="tableData"
        tooltip-effect="dark"
        :stripe="true"
        :border="true"
        height="calc(100vh - 240px )"
        style="width: 601px"
        size="mini"
        @selection-change="handleSelectionChange"
      >
        <el-table-column prop="address" label="操作" width="100">
          <template slot-scope="scope">
            <div>
                <el-button type="primary" class="edit-button" style="width: 90px;margin-bottom: 10px;" size="mini" @click="edit(scope.row)">编辑</el-button>
            </div>
          </template>
        </el-table-column> 
        <el-table-column prop="key" label="法币" width="100" />
        <el-table-column prop="value" label="收款方式" width="400" />
      </el-table>
      <!-- 分页 -->
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="pageNum"
        :limit.sync="pageSize"
        @pagination="getList"
      />
  
      <!-- 添加用户弹窗 -->
      <el-dialog
        :visible.sync="dialogVisible"
        width="700px"
        title="添加"
        :before-close="editClose"
        :close-on-click-modal="false"
      >
        <!-- 表单 -->
        <el-form ref="form" :model="active" label-width="150px" size="mini">
          <el-form-item label="法币">
            {{ active.key }}
          </el-form-item>
          <el-form-item label="收款方式">
            <el-input v-model="active.name" placeholder="请输入升级包名称"/>
          </el-form-item>
          <el-form-item>
            <el-popconfirm title="确定更新？" @confirm="bannerSave()">
              <el-button slot="reference" type="primary" class="edit-button">更新</el-button>
            </el-popconfirm>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 编辑 -->
      <el-dialog
        :visible.sync="editDialogVisible"
        width="700px"
        title="编辑"
        :before-close="editClose"
        :close-on-click-modal="false"
      >
        <!-- 表单 -->
        <el-form ref="form" :model="editForm" label-width="150px" size="mini">
          <el-form-item label="法币">
            {{ editForm.key }}
          </el-form-item>
          <el-form-item label="收款方式">
            <div>
              <div style="margin-bottom: 10px;"><el-input v-model="editForm.p1" placeholder="请输入收款方式"/></div>
            <div style="margin-bottom: 10px;"><el-input v-model="editForm.p2" placeholder="请输入收款方式"/></div>
            <div style="margin-bottom: 10px;"><el-input v-model="editForm.p3" placeholder="请输入收款方式"/></div>
            <div style="margin-bottom: 10px;"><el-input v-model="editForm.p4" placeholder="请输入收款方式"/></div>
            <div style="margin-bottom: 10px;"><el-input v-model="editForm.p5" placeholder="请输入收款方式"/></div>
            <div style="margin-bottom: 10px;"><el-input v-model="editForm.p6" placeholder="请输入收款方式"/></div>
            <div style="margin-bottom: 10px;"><el-input v-model="editForm.p7" placeholder="请输入收款方式"/></div>
            <div style="margin-bottom: 10px;"><el-input v-model="editForm.p8" placeholder="请输入收款方式"/></div>
            <div style="margin-bottom: 10px;"><el-input v-model="editForm.p9" placeholder="请输入收款方式"/></div>
            <div style="margin-bottom: 10px;"><el-input v-model="editForm.p10" placeholder="请输入收款方式"/></div>
            <div style="margin-bottom: 10px;"><el-input v-model="editForm.p11" placeholder="请输入收款方式"/></div>
            </div>
            <div><el-input v-model="editForm.p12" placeholder="请输入收款方式"/></div>
           
          </el-form-item>
          <el-form-item>
            <el-popconfirm title="确定更新？" @confirm="bannerSave()">
              <el-button slot="reference" type="primary" class="edit-button">更新</el-button>
            </el-popconfirm>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </template>
  <script>
  import Pagination from "@/components/Pagination"; // 引入分页器
  import UploadImage from "@/components/Upload/UploadPic"; // 引入分页器
  import VueUeditorWrap from "vue-ueditor-wrap"; // ES6 Module
  
  import validEmail from "@/utils/validate"; // 引入邮箱验证方法
  import md5 from "js-md5"; // 引入Md5加密
  
  export default {
    name: "Management",
    components: { Pagination, VueUeditorWrap, UploadImage },
    data() {
      return {
        option: "", // 初始选项
        options: [], // 选择角色
        name: "", // 搜索的管理员名称
        tableData: [], // 展示的表单信息
        // 添加表单
        active: {},
        // 修改表单
        editForm: {},
        total: 0, // 总数
        pageNum: 1, // 页码值
        pageSize: 20, // 页大小
        multipleSelection: [], // 选中项s
        yiFangDetailList: [], //
        dialogVisible: false, // 添加弹窗
        dialog: false, // 添加弹窗
        editDialogVisible: false, // 编辑弹窗
        Isedit: false, // 是否是编辑弹窗
        loading: false, // 表格加
        isIndex: false, // 表格加
        buttongLoding: false, // 按钮加载
        num: 24,
        isCross: false,
        isRed: false,
        isLock: false,
        isEnabled: false,
        level:1,
        receiveVisible:false,
        receiveId:'',
        receiveList:[],
        currency:""
        
      };
    },
    mounted() {
      this.getList();
    },
    methods: {
      upLoadImage1(img) {
        this.active.image = img;
      },
      upLoadImage3(img) {
        this.editForm.image = img;
      },
      handleClickItem() {
        this.$nextTick(() => {
          // 获取遮罩层dom
          const domImageMask = document.querySelector(".el-image-viewer__mask");
          if (!domImageMask) {
            return;
          }
          domImageMask.addEventListener("click", () => {
            // 点击遮罩层时调用关闭按钮的 click 事件
            document.querySelector(".el-image-viewer__close").click();
          });
        });
      },
      // 筛选
      select() {
        this.pageNum = 1;
        this.getList();
      },
      receiveEdit(id){
        this.receiveId = id
        this.$api.airdrop
          .receiveConfigView({
            id:id
          })
          .then((res) => {
            this.receiveVisible = true;
            let receiveList = res;
            let receiveList1 = []
            let item1 = {};
            let item2 = {};
            let item3 = {};
            let item4 = {};
            let item5 = {};
            let item6 = {};
            let item7 = {};
            let item8 = {};
            let item9 = {};
            let item10 = {};
            item1 = {
                pro:receiveList.length >= 1?receiveList[0].pro:'',
                nun:receiveList.length >= 1?receiveList[0].nun:'',
                amount:receiveList.length >= 1?receiveList[0].amount:""
            }
            receiveList1.push(item1)
             item2 = {
                pro:receiveList.length >= 2?receiveList[1].pro:'',
                nun:receiveList.length >= 2?receiveList[1].nun:'',
                amount:receiveList.length >= 2?receiveList[1].amount:""
            }
            receiveList1.push(item2)
             item3 = {
                pro:receiveList.length >= 3?receiveList[2].pro:'',
                nun:receiveList.length >= 3?receiveList[2].nun:'',
                amount:receiveList.length >= 3?receiveList[2].amount:""
            }
            receiveList1.push(item3)
            item4 = {
                pro:receiveList.length >= 4?receiveList[3].pro:'',
                nun:receiveList.length >= 4?receiveList[3].nun:'',
                amount:receiveList.length >= 4?receiveList[3].amount:""
            }
            receiveList1.push(item4)
            item5 = {
                pro:receiveList.length >= 5?receiveList[4].pro:'',
                nun:receiveList.length >= 5?receiveList[4].nun:'',
                amount:receiveList.length >= 5?receiveList[4].amount:""
            }
            receiveList1.push(item5)
            item6 = {
                pro:receiveList.length >= 6?receiveList[5].pro:'',
                nun:receiveList.length >= 6?receiveList[5].nun:'',
                amount:receiveList.length >= 6?receiveList[5].amount:""
            }
            receiveList1.push(item6)
            item7 = {
                pro:receiveList.length >= 7?receiveList[6].pro:'',
                nun:receiveList.length >= 7?receiveList[6].nun:'',
                amount:receiveList.length >= 7?receiveList[6].amount:""
            }
            receiveList1.push(item7)
            item8 = {
                pro:receiveList.length >= 8?receiveList[7].pro:'',
                nun:receiveList.length >= 8?receiveList[7].nun:'',
                amount:receiveList.length >= 8?receiveList[7].amount:""
            }
            receiveList1.push(item8)
            item9 = {
                pro:receiveList.length >= 9?receiveList[8].pro:'',
                nun:receiveList.length >= 9?receiveList[8].nun:'',
                amount:receiveList.length >= 9?receiveList[8].amount:""
            }
            receiveList1.push(item9)
            item10 = {
                pro:receiveList.length >= 10?receiveList[9].pro:'',
                nun:receiveList.length >= 10?receiveList[9].nun:'',
                amount:receiveList.length >= 10?receiveList[9].amount:""
            }
            receiveList1.push(item10)
            this.receiveList = receiveList1
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
          });
      },
      // 编辑
      edit(row) {
        let editForm = JSON.parse(JSON.stringify(row));
        let list = editForm.value?editForm.value.split(','):[];
        console.log(list)
        this.editForm = {
            currency:editForm.currency,
            key:editForm.key,
            p1: list.length >= 1?list[0]:'',
            p2: list.length >= 2?list[1]:'',
            p3: list.length >= 3?list[2]:'',
            p4: list.length >= 4?list[3]:'',
            p5: list.length >= 5?list[4]:'',
            p6: list.length >= 6?list[5]:'',
            p7: list.length >= 7?list[6]:'',
            p8: list.length >= 8?list[7]:'',
            p9: list.length >= 9?list[8]:'',
            p10: list.length >= 10?list[9]:'',
            p11: list.length >= 11?list[10]:'',
            p12: list.length >= 12?list[11]:'',
        }
        this.editDialogVisible = true;
      },
      // 获取表单信息
      getList() {
        var params = {
          currency:this.currency
        };
        this.loading = true;
        this.$refs.gridTable.bodyWrapper.scrollTop = 0;
        this.$api.c2c
          .ccPaymentMethodList(params)
          .then((res) => {
            let list = []
            for (var key in res) {
                let item = {
                    key:key,
                    currency:key,
                    value:res[key]
                }
                list.push(item)
            }
            this.tableData = list;
            console.log(res,this.tableData)
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
            this.loading = false;
          });
      },
  
      // 选择或者取消行，支持全选
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      // 关闭添加弹窗
      handleClose() {
        this.$refs.active.resetFields();
      },
      // 关闭修改弹窗
      editClose(done) {
        this.editInfo = {};
        done();
      },
      // 删除选中项
      handleDel() {
        var ids = [];
        this.multipleSelection.forEach((item) => {
          ids.push(item.id);
        });
        var params = {
          ids: ids.toString(),
        };
        this.$api.airdrop
          .tradeTicketDelete(params)
          .then((res) => {
            this.$message.success(res);
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
            this.getList();
          });
      },
      // 打开添加弹窗
      open() {
        this.dialogVisible = true;
        this.isEnabled = false
        this.isLock = false
        this.isIndex = false
        this.active = {}
        this.$nextTick(() => {
          this.$refs.image1.init('');
          this.$refs.image2.init('');
        });
      },
      happenTimeFun(num) {
        let date = new Date(num);
        //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM; //月补0
        let d = date.getDate();
        d = d < 10 ? "0" + d : d; //天补0
        let h = date.getHours();
        h = h < 10 ? "0" + h : h; //小时补0
        let m = date.getMinutes();
        m = m < 10 ? "0" + m : m; //分钟补0
        let s = date.getSeconds();
        s = s < 10 ? "0" + s : s; //秒补0
        return y + "-" + MM + "-" + d;
      },
      // 添加用户
      bannerSave() {
        let editForm = {
            currency:this.editForm.currency,
            p1:this.editForm.p1?this.editForm.p1:'',
            p2:this.editForm.p2?this.editForm.p2:'',
            p3:this.editForm.p3?this.editForm.p3:'',
            p4:this.editForm.p4?this.editForm.p4:'',
            p5:this.editForm.p5?this.editForm.p5:'',
            p6:this.editForm.p6?this.editForm.p6:'',
            p7:this.editForm.p7?this.editForm.p7:'',
            p8:this.editForm.p8?this.editForm.p8:'',
            p9:this.editForm.p9?this.editForm.p9:'',
            p10:this.editForm.p10?this.editForm.p10:'',
            p11:this.editForm.p11?this.editForm.p11:'',
            p12:this.editForm.p12?this.editForm.p12:'',
          
        }
        this.$api.c2c
          .ccPaymentMethodUpdate(editForm)
          .then((res) => {
            this.$message.success(res);
            this.editDialogVisible = false;
            this.getList();
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
            this.buttongLoding = false;
          });
      },
      // 打开删除弹窗
      openDelete() {
        if (!this.multipleSelection || this.multipleSelection.length < 1) {
          return this.$message.info("你并没有选中任何选项");
        }
        this.$confirm("是否删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.handleDel();
          })
          .catch(() => {
            
          });
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  .role_warp {
    font-size: 14px;
    padding: 10px;
    box-sizing: border-box;
    .role_heard_tool {
      margin-bottom: 10px;
    }
    .edit_titile {
      .dialog_input {
        // width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 70%;
        span {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          margin-right: 20px;
        }
        .el-input {
          flex: 3;
        }
      }
    }
    .tree {
      margin-top: 25px;
      display: flex;
      justify-content: space-around;
    }
    .authority_info {
      margin-top: 25px;
    }
  }
  .el-input {
    width: 70%;
  }
  </style>
  